<button
  type="button"
  [class]="
    cn(
      'inline-flex h-9 w-9 items-center justify-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 lg:hidden',
      isDark()
        ? 'text-white/85 hover:bg-white/10 focus-visible:ring-offset-ink'
        : 'text-foreground/80 hover:bg-black/5 focus-visible:ring-offset-background'
    )
  "
  [attr.aria-label]="'common.openMenu' | transloco"
  (click)="openMobile()"
>
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="h-5 w-5"
  >
    <path d="M4 5h16" />
    <path d="M4 12h16" />
    <path d="M4 19h16" />
  </svg>
</button>
